export const imageAspectRatios = {
    square: 1 / 1,
    user_page_header: 16 / 3,
    group_page_header: 14 / 3,
};

export const emptyImage = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    cropped_image: "",
    original_image: "",
};
